import React from 'react'
import Img from "gatsby-image"

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class ChicagoLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Chicago, IL" />
        <LocationMicroNav />

        <LocationContent 
          category="E-bikes" 
          title="Plugged In"
          story="We headed to the Windy City to meet with industry leaders to outline objectives and priorities for regulating electric mountain bikes. The outcomes of this meeting included the development and marketing of an eMTB map which directs riders to legal places to ride e-bikes off road. We also collectively agreed to build awareness and understanding of eMTBs among federal, state and local managers through demos, presentations, and summits."
        />      
        <Img
          title="Chicago"
          alt="Chicago bike scene"
          sizes= { this.props.data.chicagoOneOneImage.sizes }
        />              

        <LocationRelated 
          prevLocationName="Las Vegas, NV"
          prevLocationPath="las-vegas"
          prevLocationImgPath= { this.props.data.chicagoPrevImage }
          nextLocationName="Colorado"
          nextLocationPath="colorado"
          nextLocationImgPath= { this.props.data.chicagoNextImage }
        /> 
      </div>
    )
  }
}

export default ChicagoLocation

export const chicagoImageQuery = graphql`
  query chicagoImageQuery {
    chicagoOneOneImage: imageSharp(id: { regex: "/PFB_Chicago/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },    
    chicagoPrevImage: imageSharp(id: { regex: "/PFB_LASVEGAS/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    chicagoNextImage: imageSharp(id: { regex: "/PFB_COLORADO/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/chicago.js